<!-- <div class="modal-content">
  <h3 class="text-[24px] leading-[32px] text-center">Multiple Founders</h3>
  <ol>
    <li>
      Founders can select other Co-Founders.
      <ol type="a">
        <li>All Founders’ and Co-Founders’ names are listed in the Solution.</li>
        <li>Co-Founders are granted a percentage of voting rights as determined by the Founders.</li>
      </ol>
    </li>

    <li>
      Founder must select the Governing Board within 3 months of the Solution attracting 50,000 backers.
      <ol type="a">
        <li>The Board will consist of 3 or more Members (must be an odd number).</li>
        <li>Each Founder has the right to be on the Board.</li>
        <li>Board Members who are not Founders can be removed and replaced by a majority vote of the Founders.</li>
        <li>If Founders cannot agree on a decision, the Board adds their votes to break the tie.</li>
      </ol>
    </li>

    <li>
      Self-perpetuating Board.
      <ol type="a">
        <li>The Board replaces an inactive Member if the Founders don’t do so within 4 weeks.</li>
        <li>Co-Founders select the Board, if the Founders fail to do so.</li>
        <li>Backers choose the Board if the Founders/Co-Founders fail to do so.</li>
      </ol>
    </li>

    <li>
      Decision Making.
      <ol type="a">
        <li>In the beginning, the Founders make all decisions.</li>
        <li>Once the Board is seated, they make all decisions, with input from Founders and Backers, regarding authoring, editing, and promoting the Solution.</li>
      </ol>
    </li>

    <li>
      Ownership and Intellectual Property.
      <ol type="a">
        <li>All Brands/IP from the Solution are owned and controlled by the Founders.</li>
        <li>Founders can divide up ownership as they wish.</li>
      </ol>
    </li>
  </ol>
</div> -->

 <div class="flex items-center justify-center relative">
    <div class="mt-[20px]">
      <div class="text-[24px] leading-[32px] font-bold text-black text-center"
        >Multiple Founders</div>
    </div>
    <div class="absolute right-[10px]">
      <ion-buttons slot="end">
        <ion-button (click)="close()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>

<div class="modal-content h-[84vh] w-full mt-[15px] !leading-[26px]">
  The Founder is the creator of the Think Tank and holds master Admin authority to edit all content and manage the leadership team. While the initial Founder has the exclusive power to add or remove other Founders and assign ownership, additional Founders are granted Admin abilities to edit content only. For security and structure, additional Founders do not have the authority to modify the Founder roster.
  <div class="mt-[10px]"> 
  When a Member receives an invitation to become a Founder of a Think Tank, they have 7 days to accept the invitation.
  </div> 
</div>